import { DeepPartial, UserServiceStorageConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_USER_SERVICE_STORAGE_CONFIG: DeepPartial<UserServiceStorageConfig> = {
  userId: { key: 'empathy-x-id' },
  userType: { key: 'empathy-x-visit' }
};
